<script setup>
import { ref, computed, onMounted } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import { useOrderStore } from '@/stores/OrderStore';
import { useToast } from 'vue-toastification';
import { isOnline } from '@/services/healthCheck';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import CheckInventoryPopup from '../Inventory/CheckInventoryPopup.vue';

const toast = useToast();
const authStore = useAuthStore();
const orderStore = useOrderStore();

const loggedIn = computed(() => authStore.isUserLoggedIn || authStore.isManagerLoggedIn);

function onInventoryClick() {
  if (!isOnline.value) {
    toast.warning('Check inventory requires an internet connection.');
    return;
  }
  if (!loggedIn.value) return;
  authStore.toggleCheckInventoryPopup();
}

onMounted(() => {
  tippy('#inventoryTooltip', {
    content: 'Check inventory',
    animation: 'scale',
  });
});

</script>

<template>
    <div id="inventoryTooltip" class="cursor-pointer relative inline-block">
      <i
        @click="onInventoryClick"
        :class="{ 'opacity-50 cursor-not-allowed': !isOnline || !loggedIn }"
        class="pi pi-warehouse text-center text-purple-500"
        style="font-size: 1.875rem;"
      ></i>
      <!-- Requires-internet indicator (matches the offline pill / disabled menu items). -->
      <span v-if="!isOnline" class="inv-offline-dot" title="Requires an internet connection"></span>
    </div>
    <CheckInventoryPopup v-if="authStore.isCheckInventoryPopupVisible && (authStore.isUserLoggedIn || authStore.isManagerLoggedIn)" />
</template>

<style scoped>
.inv-offline-dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #dc2626;
  animation: inv-pulse 1.4s infinite;
}
@keyframes inv-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.35; } }
</style>
